export default "__VITE_ASSET__BROjHVSl__"